import {makeStyles} from "@material-ui/core";

export default makeStyles(theme => ({
  subHeader: {
    padding: '8px 16px',
    border: '1px solid #d9dcdf'
  }
}));